import { render, staticRenderFns } from "./getUnidade.vue?vue&type=template&id=75c917ab&scoped=true&"
import script from "./getUnidade.vue?vue&type=script&lang=js&"
export * from "./getUnidade.vue?vue&type=script&lang=js&"
import style0 from "./getUnidade.vue?vue&type=style&index=0&id=75c917ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c917ab",
  null
  
)

export default component.exports